import { TCSTRING_COOKIE } from "core/config";
import type WidgetConfig from "helpers/init/WidgetConfig";
import { YEAR_IN_SECONDS } from "constants/time";
import getTimestamp from "helpers/getTimestamp";
import saveLocalCookie from "helpers/saveLocalCookie";
import saveLocalStorageItem from "helpers/saveLocalStorageItem";

/**
 * Saves TCString in localstorage and first-party cookie
 *
 */
const TCFsaveLocalTCString = (
  tcString: string,
  widgetConfig: WidgetConfig,
  acString?: string | undefined | null
) => {
  const timestamp = getTimestamp();

  const cookieValue: ILocalTCStringCookieValue = {
    tcString,
    acString,
    timestamp,
    version: widgetConfig.version,
  };

  const lifetime = widgetConfig.consentLifetime || YEAR_IN_SECONDS;
  const cookieExpiry = (timestamp || getTimestamp()) + lifetime;

  saveLocalStorageItem(TCSTRING_COOKIE, cookieValue);
  saveLocalCookie(
    TCSTRING_COOKIE,
    JSON.stringify(cookieValue),
    cookieExpiry,
    widgetConfig.bulkConsent
  );
};

export interface ILocalTCStringCookieValue {
  timestamp: number | null;
  tcString: string;
  acString?: string | undefined | null;
  version: string | null;
}

export default TCFsaveLocalTCString;
